export const nameToInputType = (name, questionarioId) => {
  let qstId = questionarioId || process.env.VUE_APP_QUESTIONARIO_ID;
  if (
    qstId === "default" ||
    qstId === "massei" ||
    qstId === "ferretti" 
  )
    switch (name) {
      case "telefon":
      case "name":
      case "surname":
      case "telephone":
      case "piva":
      case "idcode":
      case "protocol_pec":
      case "birthplace":
      case "transfer":
      case "experience":
      case "error_flux_code":
      case "firstname":
      case "lastname":
      case "codfisc":
      case "phone_mobile":
      case "telefon":
      case "pec":
      case "browser":
      case "num_sessione":
        return "textInput";
      case "question":
        return "textArea";
      case "birthday":
      case "data_sessione":
        return "date";
      case "contact_times":
      case "pgpf":
      case "legal":
      case "persona":
      case "job":
      case "document_type_1":
      case "document_type_2":
      case "tipologia_utente":
      case "elenco_registro":
      case "faqhelp_persona":
      case "faqhelp_elenco_registro":
        return "select";
      case "area_preferenza":
        return "multiselect";
      case "pec_or_peo_email":
      case "email":
        return "pec_peo_switch"
      default:
        null;
    }
    //faqhelp_error_flux_code
    //faqhelp_data_sessione
    //faqhelp_num_sessione

};

export const getManualInputOrder = () => {
  return {
    'question': 10,
    'error_flux_code': 20,
    'num_sessione': 30,
    'data_sessione': 40,
    'browser': 50,
    'persona': 60,
    'elenco_registro': 70,
    'codfisc': 80,
    'name': 90,
    'birthplace': 100,
    'birthday': 110,
    'document_type_1': 120,
    'document_type_2': 130,
    'phone_mobile': 140,
    'telefon': 140,
    'pec': 150,
    'email': 160,
    'pec_or_peo_email': 170
  };
}

export const nameToInputPattern = (name, questionarioId) => {
  let qstId = questionarioId || process.env.VUE_APP_QUESTIONARIO_ID;

  if (
    qstId === "default" ||
    qstId === "massei"  ||
    qstId === "ferretti"
  )
    switch (name) {
      case "email":
      case "pec":
        return "[a-zA-Z0-9!#$%&\\-]+(?:\.[a-zA-Z0-9!#$%&\\-]+)*@[a-zA-Z0-9\\-]+(?:\.[a-zA-Z0-9\\-]+)+";
      case "telephone":
      case "telefon":
      case "mobile":
      case "piva":
      case "phone_mobile":
        return "[0-9]+";
      default:
        null;
    }
};
export const nameToInputTextMaxLength = (name) => {
  switch (name) {
    case "piva":
      return "12"
    case "codfisc":
      return "16"
    case "idCode":
      return "8"
    case "birthplace":
      return "25"
    case "email":
    case "pec":
      return "350"
    default:
      return "80"
  }
}

export const nameToInputTextType = (name) => {
  switch (name) {
    //case "piva":
    case "telefon":
    case "telephone":
    case "mobile":
      return "text"
    case "email":
    case "pec":
      return "email"
    default:
      return "text"

  }
}

export const nameToFormatDateFunction = (name, dateValue) => {
  switch (name) {
  
    default:
      const day = dateValue.getDate().toString().padStart(2, '0');
      const month = (dateValue.getMonth() + 1).toString().padStart(2, '0');
      const year = dateValue.getFullYear();
      return `${day}/${month}/${year}`;
  }
}

export const nameToSelectOptions = (name) => {
  switch (name) {
    case "contact_times":
      return [
        { value: '', text: "Seleziona" , selected: 'selected'},
        { value: "Dalle 09:00 alle 12:00", text: "Dalle 9:00 alle 12:00" },
        { value: "Dalle 15:00 alle 18:00", text: "Dalle 15:00 alle 18:00" },
      ];
    case "persona": 
      return [
        { value: '', text: "Seleziona" , selected: 'selected'},
        {value: "Fisica", text: "Fisica"},
        {value: "Giuridica", text: "Giuridica"}
      ]
    case "pgpf":
      return [
        { value: '', text: "Seleziona", selected: true },
        { value: "Persona Fisica", text: "Persona Fisica" },
        { value: "Persona Giuridica", text: "Persona Giuridica" },
      ];
    case "legal":
      return [
        { value: '', text: "Seleziona" , selected: true},
        { value: "Yes", text: "Si" },
        { value: "No", text: "No" },
      ];
    case "elenco_registro":
      return [
        { value: '', text: "Seleziona" , selected: true},
        {value: "Elenco Agenti e Mediatori", text: "Elenco Agenti e Mediatori"},
        {value: "Registro Cambiavalute", text: "Registro Cambiavalute"},
        {value: "Registro Compro Oro", text: "Registro Compro Oro"},
        {value: "Registro Operatori professionali in oro", text: "Registro Operatori professionali in oro"},
        {value: "PSP/IMEL e Punti di contatto centrale", text: "PSP/IMEL e Punti di contatto centrale"},
        {value: "Registro Merchant", text: "Registro Merchant"},

      ]
    case "job":
      return [
        { value: '', text: "Seleziona", selected: true },
        {
          value:
            "Associazione di categoria Iscritti negli Elenchi e/o Registri OAM",
          text: "Associazione di categoria Iscritti negli Elenchi e/o Registri OAM",
        },
        {
          value: "Intermediario finanziario e bancario Istituto di pagamento",
          text: "Intermediario finanziario e bancario Istituto di pagamento",
        },
        {
          value:
            "Istituto di moneta elettronica Professionista, che formula la domanda in nome e per conto di un operatore iscritto in uno degli Elenchi e/o Registri OAM",
          text: "Istituto di moneta elettronica Professionista, che formula la domanda in nome e per conto di un operatore iscritto in uno degli Elenchi e/o Registri OAM",
        },
        {
          value: "Non appartengo a nessuna tra le precedenti categorie",
          text: "Non appartengo a nessuna tra le precedenti categorie",
        },
      ];
    case "document_type_1":
      return [
        { value: '', text: "Seleziona" , selected: true},
        { value: "Carta di identità", text: "Carta d'identità" },
        { value: "Patente di guida", text: "Patente di guida" },
        { value: "Passaporto", text: "Passaporto" },
      ];
    case "document_type_2":
      return [
        { value: '', text: "Seleziona" , selected: true},
        { value: "Carta di identità", text: "Carta d'identità" },
        { value: "Patente di guida", text: "Patente di guida" },
        { value: "Passaporto", text: "Passaporto" },
      ];
    case "area_preferenza":
      return [
        { value: "Ufficio Affari Legali", text: "Ufficio Affari Legali" },
        { value: "Ufficio IT e Privacy", text: "Ufficio IT e Privacy" },
        { value: "Ufficio Vigilanza", text: "Ufficio Vigilanza" },
        { value: "Ufficio Amministrazione, Finanza e Controllo", text: "Ufficio Amministrazione, Finanza e Controllo" },
        { value: "Ufficio Elenchi", text: "Ufficio Elenchi" },
        { value: "Ufficio del Personale e Segreteria Generale", text: "Ufficio del Personale e Segreteria Generale" },
        { value: "Ufficio Centro Studi", text: "Ufficio Centro Studi" },
      ];
    default:
      return [];
  }
};
